import React, { Component, useState, useEffect } from 'react';
import sectiondata from '../../data/sections.json';
import parse from 'html-react-parser';
import { Link } from 'react-router-dom';
import { GetCityList } from '../../request/apiRquest';


export const PropertiesByCities = () => {

  const [cities, setCities] = useState([])


  const getCityList = () => {
    GetCityList().then((res) => {
      setCities(res);
    })
  }

  useEffect(() => {
    getCityList();
  }, []);


  let publicUrl = process.env.PUBLIC_URL + '/'
  let imagealt = 'image'
  let data = sectiondata.propertiesbycities

  const inlineStyle = {
    backgroundImage: 'url(' +  '/assets/img/bg/2.png)'
  }

  return <div className="city-intro-area pd-bottom-70" style={inlineStyle}>
    {/* city area start */}
    <div className="city-area pd-top-92">
      <div className="container">
        <div className="section-title text-center">
          <h2 className="title">{data.title}</h2>
            <Link className="btn-view-all" to="/search-grid">View All</Link>
        </div>
        <div className=" row">
          <div className="" />

          {data.items.slice(0, 6).map((item, i) =>
            <div key={i} className={"" + item.class}>
              <div className={"single-city " + item.sectionclass}>
                <div className="sc-overlay" />
                <div className="thumb">
                  <img src={publicUrl + item.image} alt={imagealt} />
                </div>
                <div className="details">
                  {cities[i] &&  (
                    <h5 className="title"><a href={`/search-grid?Cities=${cities[i].id}`}>{cities[i]?.name}</a></h5>
                  )}

                  {/* <p>{item.content}</p> */}
                  {/* area properties ki api se lengh map krna hai  */}
                </div>
              </div>
            </div>
          )}

        </div>
      </div>
    </div>
    {/* city area end */}
    {/* intro area start */}
    <div className="intro-area pd-top-70">
      <div className="container">
        <div className="row">
          {data.intro.map((item, i) =>
            <div key={i} className="col-md col-sm-6-6">
              <a href={item.url} className={"single-intro-media media " + item.class}>
                <div className="media-left">
                  <img src={publicUrl + item.icon} alt={imagealt} />
                </div>
                <div className="media-body">
                  <h4>{item.title}</h4>
                  <p>{item.content}</p>
                </div>
              </a>
            </div>

          )}

        </div>
      </div>
    </div>
    {/* intro area start */}
  </div>



}

export default PropertiesByCities